import { Form } from 'antd';
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import CalendarPicker from './CalendarPicker';
import { Moment } from 'moment';
import { useInquiryDayOffs } from '../hooks';
type Props = {
  value?: Moment;
  onPickDate: (date: moment.Moment) => Promise<void>
};
export type TimeSelectionRef = {
  fetch: (date: Moment) => void;
};
export const useTimeSelection = () => useRef<TimeSelectionRef>(null);
const TimeSelection = forwardRef<TimeSelectionRef, Props>(({ onPickDate }, ref) => {
  const form = Form.useFormInstance();
  const dayOffs: Moment[] = Form.useWatch('dayOffs', form) || [];
  const cacheDate = useRef({
    startTime: '',
    endTime: '',
  });
  const [_dateOffState, fetchDateOff] = useInquiryDayOffs({
    onStart: ({ endTime, startTime }) => {
      cacheDate.current.startTime = startTime;
      cacheDate.current.endTime = endTime;
    },
    onDone(data) {
      form.setFieldValue('dayOffs', data);
    },
  });
  const handleFetch = (date: Moment) => {
    const now = date;
    const startTime = now.clone().subtract(1, 'month').startOf('month').format('MM-DD-YYYY');
    const endTime = now.clone().add(1, 'month').endOf('month').format('MM-DD-YYYY');
    if (cacheDate.current.startTime === startTime && cacheDate.current.endTime === endTime) return;
    fetchDateOff(startTime, endTime);
  };

  const onMonthChange = (now: Moment) => {
    const startTime = now.clone().subtract(1, 'month').startOf('month').format('MM-DD-YYYY');
    const endTime = now.clone().add(1, 'month').endOf('month').format('MM-DD-YYYY');
    fetchDateOff(startTime, endTime);
  };

  useImperativeHandle(ref, () => ({
    fetch: handleFetch,
  }));

  return (
    <Form.Item noStyle name={'date'} rules={[{ required: true }]}>
      <CalendarPicker offDates={dayOffs || _dateOffState.data} onPickDate={onPickDate} onMonthChange={onMonthChange} />
    </Form.Item>
  );
});
TimeSelection.displayName = 'TimeSelection';
export { TimeSelection };
